import React from "react";
import "./Approach.css";

const Approach = () => {
    return (
        <div id="approach-container">
            <div id="approach-header">Our Approach</div>
            <div id="approach-sub-header">To be the best and deliver the best.</div>
            <div className="row">
                <div className="col-md-12 col-lg-4 col-xl-4 col-sm-12" data-aos="zoom-in">
                    <div className="approach-box" id="approach-box-1">
                        <div className="approach-number">1.</div>
                        <div className="approach-box-header">Open
                            <br/>
                            Communication</div>
                        <p className="approach-box-body">We strive for transparent communication to help
                            us foster a collaborative environment both internally and with our clients.</p>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-xl-4 col-sm-12" data-aos="zoom-in">
                    <div className="approach-box" id="approach-box-2">
                        <div className="approach-number">2.</div>
                        <div className="approach-box-header">Agile
                            <br/>
                            Methods</div>
                        <p className="approach-box-body">Our agile team dynamics ensure that our teams
                            are high-performing and adaptable for the changing nature of business.</p>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-xl-4 col-sm-12" data-aos="zoom-in">
                    <div className="approach-box" id="approach-box-3">
                        <div className="approach-number">3.</div>
                        <div className="approach-box-header">Clean &<br/>
                            Efficient Code</div>
                        <p className="approach-box-body">We pride ourselves on writing robust and
                            easy-to-follow code while maintaining industry best practices.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Approach;


// WEBPACK FOOTER //
// ./src/components/Mainpage/Approach/Approach.js